// extracted by mini-css-extract-plugin
module.exports = {"container":"_2bmpMo6xuqywEQp4Nzsl0A=="};